import { Tabs, Tab } from "@podtrac/common/tabs";
import { FaSpotify } from "react-icons/fa";
import { SiApplepodcasts } from "react-icons/si";
import { NavLink, Outlet } from "react-router-dom";

export function ShowRankingsLayout() {
    return (
        <>
            <Tabs>
                <Tab>
                    <NavLink to="podtrac">
                        <img
                            src="/favicon.96x96.png"
                            style={{ height: "1em" }}
                        />
                        Podtrac Rankings
                    </NavLink>
                </Tab>
                <Tab>
                    <NavLink to="apple">
                        <SiApplepodcasts fill="#9d40d3" />
                        Apple Podcasts Rankings
                    </NavLink>
                </Tab>
                <Tab>
                    <NavLink to="spotify">
                        <FaSpotify fill="#1dd05d" />
                        Spotify Rankings
                    </NavLink>
                </Tab>
            </Tabs>
            <Outlet />
        </>
    );
}
